import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { hosts } from "@/mocks/streams";
import { formatFollowers } from "@/lib/format";

export default function NewHosts() {
  const navigate = useNavigate();
  const [followed, setFollowed] = useState<string[]>([]);

  const toggleFollow = (id: string) => {
    setFollowed((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-5 md:p-6">
      <div className="mb-5 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h3 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
            <span className="w-5 h-5 flex items-center justify-center text-accent-400">
              <i className="ri-star-smile-line"></i>
            </span>
            新晋主播推荐
          </h3>
          <p className="mt-1 text-sm text-foreground-400">发现刚刚起步的新主播，关注和支持他们的第一次直播</p>
        </div>
        <span className="text-xs text-foreground-400">本周新增 {hosts.length} 位主播</span>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {hosts.map((host) => {
          const isFollowed = followed.includes(host.id);
          return (
            <div
              key={host.id}
              className="flex items-start gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4"
            >
              <button
                type="button"
                onClick={() => navigate(`/category/${host.categoryId}`)}
                className="w-14 h-14 flex-shrink-0 overflow-hidden rounded-full border border-background-300"
              >
                <img src={host.avatar} alt={`主播 ${host.name}`} className="h-full w-full object-cover" />
              </button>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="truncate text-sm font-medium text-foreground-900">{host.name}</span>
                  <span className="rounded-md bg-secondary-100/10 px-1.5 py-0.5 text-[10px] text-foreground-400">
                    {host.level}
                  </span>
                </div>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-400">{host.bio}</p>
                <div className="mt-2 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{formatFollowers(host.followers)} 粉丝</span>
                  <button
                    type="button"
                    onClick={() => toggleFollow(host.id)}
                    className={`rounded-md px-3 py-1 text-xs transition-colors whitespace-nowrap ${
                      isFollowed
                        ? "bg-background-200 text-foreground-500 hover:text-foreground-800"
                        : "bg-accent-500 text-background-50 hover:bg-accent-600"
                    }`}
                  >
                    {isFollowed ? "已关注" : "+ 关注"}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}